import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "nav-item" }

import { links } from "@/constants";
import { useProductsStore } from "@/stores/ProductsStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavbarLinks',
  props: { className: { type: String, default: "" } },
  setup(__props) {



const productsStore = useProductsStore();
const fetchRequiredData = () => {
  if (productsStore.didFetchOnce) return;

  productsStore.fetchProducts();
  productsStore.didFetchOnce = true;
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(["navbar-nav ms-auto", __props.className]),
    onMouseenter: fetchRequiredData
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(links), (link) => {
      return (_openBlock(), _createElementBlock("li", _hoisted_1, [
        (_openBlock(), _createBlock(_component_RouterLink, {
          role: "link",
          class: "nav-link text-capitalize",
          to: { name: link.name },
          "active-class": "activeLink",
          key: link.name,
          onMouseenter: ($event: any) => (link.name === 'products' ? fetchRequiredData : null)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(link.name), 1)
          ]),
          _: 2
        }, 1032, ["to", "onMouseenter"]))
      ]))
    }), 256))
  ], 34))
}
}

})